import { styled } from "styled-components";
export const H1 = styled.h1`
  font-size: 24px;
  color: ${(props) => props.color || "var(--white)"};
`;
